<template>
  <div class="tonglan">
    <div class="xwlb">
      <div id="lbl" class="lbl">
        <div class="dbti" id="conent">
          <h1 style="text-align: center; height: 40px; padding-top: 25px">
            服务协议
          </h1>
          <h2 style="height: 30px"></h2>
          <p id="con"></p>

          <p class="MsoNormal" align="left">
            &emsp;&emsp;<b><span style="font-size: 16px">1&nbsp;</span></b
            ><b><span style="font-size: 16px">用户身份保证</span></b>
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px"
              >1.1用户承诺并保证自己是具有完全民事行为能力和完全民事权利能力的自然人、法人、实体和组织。用户在此保证所填写的用户信息是真实、准确、完整、及时的，并且没有任何引人误解或者虚假的陈述，且保证药聚多可以通过用户所填写的联系方式与用户取得联系。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px"
              >1.2用户应根据药聚多对于相关服务的要求及时提供相应的身份证明、企业证明等资料，否则药聚多有权拒绝向该会员或用户提供相关服务。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px"
              >1.3用户承诺将及时更新其用户信息以维持其在平台信息的有效性。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px"
              >1.4如果用户提供的资料或信息包含有不正确、不真实的信息，药聚多保留取消用户会员资格并随时结束为该用户提供服务的权利。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px"
              >1.5以代理人身份代理其他自然人或者单位进行注册用户必须向药聚多提供代理人和被代理人的详细资料和信息及授权书面文件，未向药聚多提供上述资料信息及文件的，药聚多将视注册者为会员。</span
            >
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<b><span style="font-size: 16px">2&nbsp;</span></b
            ><b><span style="font-size: 16px">会员身份确认</span></b>
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px"
              >2.1成为平台用户后将得到一个用户名和密码，用户凭用户名和密码享受药聚多向其会员用户提供的商品和服务。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px"
              >2.2用户将对用户名和密码安全负全部责任，并且用户对以其用户名进行的所有活动和事件负全责。用户有权根据药聚多规定的程序修改密码。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px"
              >2.3非经药聚多书面同意，用户名和密码不得擅自转让或者授权他人使用，否则用户应承担由此造成的一切后果。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px"
              >2.4用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通告药聚多。</span
            >
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<strong
              ><span style="font-size: 16px">3 用户的权利和义务</span></strong
            >
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px"
              >3.1
              用户有权利拥有自己在药聚多的用户名和密码并有权利使用自己的用户名和密码随时登录药聚多平台。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left">
            &emsp;&emsp;<span style="font-size: 14px"
              >3.2用户有权利享受药聚多提供的互联网技术和信息服务，并有权利在接受药聚多提供的服务时获得药聚多的技术支持、咨询等服务。</span
            ><span></span>
          </p>
          <p>
            &emsp;&emsp;<span style="font-size: 14px"
              >3.3用户保证不会利用技术或其他手段破坏及扰乱药聚多平台。</span
            >
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >3.4用户应尊重药聚多及其他第三方的知识产权和其他合法权利，并保证在发生上述事件时尽力保护药聚多及其股东、雇员、合作伙伴等免于因该等事件受到影响或损失；药聚多保留用户侵犯药聚多知识产权时终止向该用户提供服务并不退还任何款项的权利。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >3.5对由于用户给药聚多提供的联络方式有误而导致的一切后果，用户应自行承担责任，包括但不限于因用户未能及时收到药聚多的相关通知而导致的后果和损失。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >3.6用户保证其使用药聚多服务时将遵从国家、地方法律法规、行业惯例和社会公共道德，不会利用药聚多提供的服务进行存储、发布、传播如下信息和内容：违反国家法律法规政策的任何内容（信息）；违反国家规定的政治宣传和</span
            ><span style="font-size: 14px">/</span
            ><span style="font-size: 14px">或新闻信息；涉及国家秘密和</span
            ><span style="font-size: 14px">/</span
            ><span style="font-size: 14px">或安全的信息；封建迷信和</span
            ><span style="font-size: 14px">/</span
            ><span style="font-size: 14px"
              >或淫秽、色情、下流的信息或教唆犯罪的信息；博彩有奖、赌博游戏；违反国家民族和宗教政策的信息；妨碍互联网运行安全的信息；侵害他人合法权益的信息和</span
            ><span style="font-size: 14px">/</span
            ><span style="font-size: 14px"
              >或其他有损于社会秩序、社会治安、公共道德的信息或内容。用户同时承诺不得为他人发布上述不符合国家规定和</span
            ><span style="font-size: 14px">/</span
            ><span style="font-size: 14px"
              >或本服务条款约定的信息内容提供任何便利，包括但不限于设置</span
            ><span style="font-size: 14px">URL</span
            ><span style="font-size: 14px">、</span
            ><span style="font-size: 14px">BANNER</span
            ><span style="font-size: 14px"
              >链接等。用户承认药聚多有权在用户违反上述时有权终止向用户提供服务并不于退还任何款项，因用户上述行为给药聚多造成损失的，用户应予赔偿。</span
            >
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<b><span style="font-size: 16px">4 </span></b
            ><b><span style="font-size: 16px">药聚多的权利和义务</span></b>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >4.1药聚多应根据用户所属会员类型向用户提供合格的网络技术和信息服务。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >4.2药聚多承诺对用户资料采取对外保密措施，不向第三方披露用户资料，不授权第三方使用用户资料，除非：</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px">（</span
            ><span style="font-size: 14px">1</span
            ><span style="font-size: 14px"
              >）依据本协议条款或者用户与药聚多之间其他服务协议、合同、在线条款等规定可以提供；</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px">（</span
            ><span style="font-size: 14px">2</span
            ><span style="font-size: 14px">）依据法律法规的规定应当提供；</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px">（</span
            ><span style="font-size: 14px">3</span
            ><span style="font-size: 14px"
              >）行政、司法等有权部门要求药聚多提供；</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px">（</span
            ><span style="font-size: 14px">4</span
            ><span style="font-size: 14px">）用户同意药聚多向第三方提供；</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px">（</span
            ><span style="font-size: 14px">5</span
            ><span style="font-size: 14px"
              >）药聚多解决举报事件、提起诉讼而提交的；</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px">（</span
            ><span style="font-size: 14px">6</span
            ><span style="font-size: 14px"
              >）药聚多为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提交的；</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px">（</span
            ><span style="font-size: 14px">7</span
            ><span style="font-size: 14px"
              >）药聚多为向用户提供产品、服务、信息而向第三方提供的，包括药聚多通过第三方的技术及服务向用户提供产品、服务、信息的情况。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >4.3药聚多有权使用用户资料。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >4.4药聚多有权利对用户进行审查并决定是否接受用户成为药聚多会员或是否与用户进行某一交易。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >4.5药聚多保留在用户违反国家、地方法律法规规定或违反本注册条款的情况下终止为用户提供服务并终止用户账号的权利，并且在任何情况下，药聚多对任何间接、偶然、特殊及继起的损害不负责任。</span
            >
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<b><span style="font-size: 16px">5&nbsp;</span></b
            ><b><span style="font-size: 16px">联络与沟通</span></b>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >用户充分理解药聚多将通过会员留下的联系方式与会员保持联络及沟通，用户在此同意药聚多包括但不限于系统推送、邮件、短信等向其发送包括会员信息、药聚多商品及服务信息在内的相关商业及非商业联络信息。</span
            >
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<br />
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<b><span style="font-size: 16px">6 </span></b
            ><b
              ><span style="font-size: 16px"
                >服务条款的修改和服务体系修订</span
              ></b
            >
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >药聚多有权在必要时修改服务条款，药聚多服务条款一旦发生变动，将会在相关页面公告修改的事实，无需对用户进行单独通知。如果不同意所改动的内容，用户可以主动取消获得的网络服务。如果用户继续享用药聚多网络服务，则视为接受服务条款的变动。药聚多保留随时修改其服务体系和价格而不需通知用户的权利，药聚多修改其服务和价格体系之前用户就具体服务与药聚多达成协议并已按照约定交纳费用的，药聚多将按照已达成的协议执行至已交纳费用的服务期期满。</span
            >
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<br />
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<b><span style="font-size: 16px">7 </span></b
            ><b><span style="font-size: 16px">服务的终止</span></b>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >7.1 用户有权随时申请终止其会员资格，但已交纳款项不予退还。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >7.2药聚多有权根据实际情况决定取消为用户提供服务，但应退还用户为该服务所交纳款项的剩余部分，除此之外药聚多不承担任何责任。</span
            >
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<br />
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<b><span style="font-size: 16px">8 </span></b
            ><b><span style="font-size: 16px">争议解决及法律适用</span></b>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >8.1因本服务条款有关的一切争议，双方当事人应通过友好协商方式解决。如果协商未成，双方同意向药聚多主要经营地的人民法院起诉。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >8.2本服务条款的效力、解释、履行和争议的解决均适用中华人民共和国法律法规和计算机、互联网行业的规范。</span
            >
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p style="text-align: left">
            &emsp;&emsp;<b><span style="font-size: 16px">9 </span></b
            ><b><span style="font-size: 16px">不可抗力</span></b>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >9.1
              因不可抗力或者其他意外事件，使得本条款履行不可能、不必要或者无意义的，遭受不可抗力、意外事件的一方不承担责任。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >9.2、不可抗力、意外事件是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >9.3
              用户同意鉴于互联网的特殊性，黑客攻击、互联网连通中断或者系统故障等属于不可抗力，由此给用户或者第三方造成的损失不应由药聚多承担。</span
            >
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<br />
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<b><span style="font-size: 16px">10 </span></b
            ><b><span style="font-size: 16px">附则</span></b>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >10.1
              本注册条款中有关条款若被权威机构认定为无效，不应影响其他条款的效力，也不影响本服务条款的解释、违约责任及争议解决的有关约定的效力。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >10.2
              一方变更通知、通讯地址或其他联系方式，应自变更之日起及时将变更后的地址、联系方式通知另一方，否则变更方应对此造成的一切后果承担责任。用户同意，药聚多的有关通知只需在药聚多平台上发布即视为送达用户。</span
            ><span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 14px"
              >10.3
              因药聚多上市、被收购、与第三方合并、名称变更等事由，用户同意药聚多可以将其权利和</span
            ><span style="font-size: 14px">/</span
            ><span style="font-size: 14px">或义务转让给相应的药聚多权利</span
            ><span style="font-size: 14px">/</span
            ><span style="font-size: 14px"
              >义务的承受者。用户在此再次保证已经完全阅读并理解了上述条款并自愿正式成为药聚多会员，接受上述所有条款的约束。</span
            ><span></span>
          </p>
          <p>&emsp;&emsp;<br /></p>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Service'
}
</script>
